import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { APP_SETTINGS } from '../models/backofficeConfiguration';
import { ExecuteService } from './executeService.service';
import { ErrorHandlerService } from './errorHandler.service';
import { DraftSeo, PostSeo } from '../models/PostSeo';
import { Post } from '../models/post';

@Injectable()
export class PostService {

  constructor(private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public GetByUrl(postFullUrl: string, locale: string): Observable<Post> {
    let postUrl = '';
    const pathName = new URL(postFullUrl).pathname;
    const indexOf = pathName.lastIndexOf('/');
    if (indexOf > -1){
      postUrl = encodeURIComponent(pathName.substring(indexOf + 1).replace(/\//g, '+'));
    }
    else {
      postUrl = encodeURIComponent(pathName.replace(/\//g, '+')); 
    }

    const requestUrl = `${APP_SETTINGS.PostApiUrl}api/postManager/${locale}/getByUrl/${postUrl}`;
    return this.executeService.Execute('get', requestUrl)
      .pipe(
        catchError(this.errorHandler.handleError<object[]>('PostService_GetPostByUrl', null))
      );
  }

  public GetById(id: string, locale: string, ignoreNotFound: boolean = false): Observable<PostSeo> {
    const requestUrl = `${APP_SETTINGS.PostApiUrl}${locale}/post/${id}`;
    return this.executeService.ExecuteWithToken('get', requestUrl)
      .pipe(
        catchError(this.errorHandler.handleError<object[]>('PostService_GetPostById', null, ignoreNotFound))
      );
  }

  public CreatePost(locale: string, post: PostSeo): Observable<PostSeo> {
    const postUrl = `${APP_SETTINGS.PostApiUrl}${locale}/post/`;

    return this.executeService.ExecuteWithToken('post', postUrl, null, post)
      .pipe(catchError(this.errorHandler.handleAndThrowError('PostService_CreatePost', null, false)));
  }

  public UpdatePost(locale: string, post: PostSeo): Observable<PostSeo> {
    const postUrl = `${APP_SETTINGS.PostApiUrl}${locale}/post/${post.Id}`;

    return this.executeService.ExecuteWithToken('put', postUrl, null, post)
      .pipe(catchError(this.errorHandler.handleAndThrowError('PostService_UpdatePost', null, false)));
  }

  public CreateDraft(locale: string, post: DraftSeo): Observable<DraftSeo> {
    const postUrl = `${APP_SETTINGS.PostApiUrl}${locale}/post/draft`;

    return this.executeService.ExecuteWithToken('post', postUrl, null, post)
      .pipe(catchError(this.errorHandler.handleAndThrowError('PostService_CreateDraft', null, false)));
  }

  public UpdateDraft(locale: string, post: DraftSeo): Observable<DraftSeo> {
    const postUrl = `${APP_SETTINGS.PostApiUrl}${locale}/post/draft/${post.Id}`;

    return this.executeService.ExecuteWithToken('put', postUrl, null, post)
      .pipe(catchError(this.errorHandler.handleAndThrowError('PostService_UpdateDraft', null, false)));
  }

  public DeleteDraft(locale: string, id: string): Observable<PostSeo> {
    const postUrl = `${APP_SETTINGS.PostApiUrl}${locale}/post/draft/${id}`;

    return this.executeService.ExecuteWithToken('delete', postUrl, null)
      .pipe(catchError(this.errorHandler.handleAndThrowError('PostService_DeleteDraft', null, false)));
  }

  public GetDraftById(locale: string, id: string): Observable<PostSeo> {
    const postUrl = `${APP_SETTINGS.PostApiUrl}${locale}/post/draft/${id}`;

    return this.executeService.ExecuteWithToken('get', postUrl, null)
      .pipe(catchError(this.errorHandler.handleAndThrowError('PostService_GetDraftById', null, false)));
  }

  public BuildLinks(locale: string, content: any, url: string): Observable<string> {
    const postUrl = `${APP_SETTINGS.EditorialToolsApiUrl}v2/${locale}/linkBuilder`;
    const json = {
      url: url,
      content: content
    }
    const body: any = JSON.stringify(json);
    return this.executeService.ExecuteWithToken('post', postUrl, null, body, 'text')
      .pipe(catchError(this.errorHandler.handleAndThrowError('PostService_BuildLinks', null, false)));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/post.service.ts